import { Button, Head, Link } from "zudoku/components";
import { Plane, Ship, Truck } from "zudoku/icons";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "zudoku/ui/Card";

const LandingPage = () => {
	return (
		<section className="bg-background pb-24 text-foreground">
			<Head>
				<title>Home</title>
			</Head>

			{/* Hero */}
			<div className="flex flex-col items-center justify-center px-8 py-40 text-center">
				<h1 className="mb-4 text-5xl font-bold">CaaS API</h1>
				<p className="mb-8 max-w-2xl text-xl text-muted-foreground">
					Unlock your connected capabilities with{" "}
					<span className="bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
						real-time asset insights
					</span>
					.
				</p>
				<Button asChild size="lg">
					<Link to="/introduction">
						<p className="font-semibold">Get started</p>
					</Link>
				</Button>
			</div>

			{/* Feature highlights */}
			<div className="mx-auto mt-16 max-w-6xl px-6 lg:px-12">
				<div className="mt-10 grid gap-6 md:grid-cols-3">
					<Card className="border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900/60">
						<CardHeader>
							<CardTitle className="flex items-center gap-2">
								<Truck size={24} className="text-primary" />
								Mobility
							</CardTitle>
							<CardDescription>
								Enhance your fleet efficiency with real-time data insights.
							</CardDescription>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Monitor vehicle locations, optimise routing, and manage charging
								schedules. Reduce costs with predictive maintenance, and provide
								drivers with personalised insurance policies, tailored to their driving habits.
							</p>
						</CardContent>
					</Card>

					<Card className="border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900/60">
						<CardHeader>
							<CardTitle className="flex items-center gap-2">
								<Plane size={24} className="text-primary" />
								Aviation
							</CardTitle>
							<CardDescription>
								Deliver accurate billing with real-time session data for ground power units.
							</CardDescription>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Access current and historical ground power session data to
								enable precise, transparent billing. Detect asset misuse and
								reduce unplanned downtime.
							</p>
						</CardContent>
					</Card>

					<Card className="border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-900/60">
						<CardHeader>
							<CardTitle className="flex items-center gap-2">
								<Ship size={24} className="text-primary" />
								Marine
							</CardTitle>
							<CardDescription>
								Port monitoring and fleet usage optimisation.
							</CardDescription>
						</CardHeader>
						<CardContent>
							<p className="text-sm text-muted-foreground">
								Track vessel locations, optimise fuelling and routing, and
								minimise port downtime with real-time operational insights.
							</p>
						</CardContent>
					</Card>
				</div>
			</div>

			{/* Supporting statement */}
			<div className="mx-auto mt-20 max-w-6xl px-6">
				<p className="text-center justify-center text-lg text-muted-foreground md:text-xl lg:px-48">
					Everything you need to deliver connected asset experiences,
					<br /> from proof-of-concept to scaled production.
				</p>
			</div>

			{/* Final CTA */}
			<div className="mx-auto mt-20 max-w-5xl rounded-lg border border-slate-100 bg-white px-8 py-12 text-center shadow-md dark:border-slate-700 dark:bg-slate-900 dark:shadow-none">
				<h3 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 md:text-3xl">
					Ready to explore what your data can do?
				</h3>
				<div className="mt-6 flex flex-wrap items-center justify-center gap-3">
					<Button asChild size="lg" className="px-7">
						<Link to="https://beamconnectivity.com/contact/">
							<p className="font-semibold">Speak to our team</p>
						</Link>
					</Button>
					<Button
						asChild
						variant="ghost"
						size="lg"
						className="text-primary hover:bg-primary/10 dark:hover:bg-primary/20"
					>
						<Link to="/introduction">View developer documentation</Link>
					</Button>
				</div>
			</div>
		</section>
	);
};

export default LandingPage;
